/* eslint-disable */
import { ComponentStyleSheetDefinition, Component } from '../index';

declare var Object: any;
export interface ComponentStyleSheetInterface {
  id?: string;
  value?: string;
  componentStyleSheetDefinitionId?: string;
  componentId?: string;
  createdDate?: Date;
  createdBy?: string;
  createdById?: string;
  updatedDate?: Date;
  updatedBy?: string;
  updatedById?: string;
  definition?: ComponentStyleSheetDefinition;
  component?: Component;
}

export class ComponentStyleSheet implements ComponentStyleSheetInterface {
  'id': string;
  'value': string;
  'componentStyleSheetDefinitionId': string;
  'componentId': string;
  'createdDate': Date;
  'createdBy': string;
  'createdById': string;
  'updatedDate': Date;
  'updatedBy': string;
  'updatedById': string;
  definition: ComponentStyleSheetDefinition;
  component: Component;
  constructor(data?: ComponentStyleSheetInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `ComponentStyleSheet`.
   */
  public static getModelName() {
    return 'ComponentStyleSheet';
  }
  /**
   * @method factory
   * @author Jonathan Casarrubias
   * @license MIT
   * This method creates an instance of ComponentStyleSheet for dynamic purposes.
   **/
  public static factory(
    data: ComponentStyleSheetInterface
  ): ComponentStyleSheet {
    return new ComponentStyleSheet(data);
  }
  /**
   * @method getModelDefinition
   * @author Julien Ledun
   * @license MIT
   * This method returns an object that represents some of the model
   * definitions.
   **/
  public static getModelDefinition() {
    return {
      name: 'ComponentStyleSheet',
      plural: 'ComponentStyleSheets',
      path: 'component-style-sheets',
      idName: 'id',
      properties: {
        id: {
          name: 'id',
          type: 'string',
        },
        value: {
          name: 'value',
          type: 'string',
        },
        componentStyleSheetDefinitionId: {
          name: 'componentStyleSheetDefinitionId',
          type: 'string',
        },
        componentId: {
          name: 'componentId',
          type: 'string',
        },
        createdDate: {
          name: 'createdDate',
          type: 'Date',
        },
        createdBy: {
          name: 'createdBy',
          type: 'string',
        },
        createdById: {
          name: 'createdById',
          type: 'string',
        },
        updatedDate: {
          name: 'updatedDate',
          type: 'Date',
        },
        updatedBy: {
          name: 'updatedBy',
          type: 'string',
        },
        updatedById: {
          name: 'updatedById',
          type: 'string',
        },
      },
      relations: {
        definition: {
          name: 'definition',
          type: 'ComponentStyleSheetDefinition',
          model: 'ComponentStyleSheetDefinition',
          relationType: 'belongsTo',
          keyFrom: 'componentStyleSheetDefinitionId',
          keyTo: 'id',
        },
        component: {
          name: 'component',
          type: 'Component',
          model: 'Component',
          relationType: 'belongsTo',
          keyFrom: 'componentId',
          keyTo: 'id',
        },
      },
    };
  }
}
